import { UserMin } from '@g17eco/types/user';
import './NonStaffOnboardingMTHoldingPage.scss';

export const NonStaffOnboardingMTHoldingPage = ({ user }: { user: Pick<UserMin, 'email' | 'telephoneNumber'> }) => {
  return (
    <div className='holding__page__container d-flex align-items-center justify-content-center text-center'>
      <div>
        <div className='text-ThemeHeadingMedium title'>Congratulations</div>
        <h2 className='my-4 fw-semibold'>You've successfully completed the setup process.</h2>
        <h4 className='text-ThemeHeadingLight '>
          A member of our team will reach out shortly to provide you with access to your account.
        </h4>
        <h4 className='text-ThemeHeadingLight'>Please keep an eye on your phone and email for updates.</h4>
        <h3 className='text-ThemeHeadingLight fw-bold'>{user.email}</h3>
        <h3 className='text-ThemeHeadingLight fw-bold'>{user.telephoneNumber}</h3>
        <h4 className='text-ThemeHeadingLight'>Thank you for your patience as we finalise your setup.</h4>
      </div>
    </div>
  );
};
